module.exports = __webpack_public_path__ + "img/pubpeer-extensions.b5665e3f.png";